import { connect } from "react-redux";
import { compose } from "redux";

import { getHomeSponsors } from "./actions";
import Component from "./homeSponsors";
import {
  makeSelectHomeSponsors,
  makeSelectIsError,
  makeSelectIsReady,
} from "./reducer";

const makeMapStateToProps = () => {
  const selectHomeSponsors = makeSelectHomeSponsors();
  const selectIsReady = makeSelectIsReady();
  const selectIsError = makeSelectIsError();

  const mapStateToProps = (state, ownProps) => ({
    isReady: selectIsReady(state, ownProps),
    isError: selectIsError(state, ownProps),
    sponsors: selectHomeSponsors(state, ownProps),
  });

  return mapStateToProps;
};

const mapDispatchToProps = (dispatch) => ({
  onGetHomeSponsors: (data) => dispatch(getHomeSponsors(data)),
});

export function fetchData(store) {
  return store.dispatch(getHomeSponsors());
}

export default compose(connect(makeMapStateToProps, mapDispatchToProps))(
  Component
);
